import { JuloUpdateEntry } from "./types"

export const egnaMeddelandemallarEntry: JuloUpdateEntry = {
  slug: "2026-08-26-egna-meddelandemallar",
  date: "2026-08-26",
  title: "Egna meddelandemallar",
  description:
    'Ni kan nu spara helt egna meddelandemallar för texter ni skickar ofta. Skapa och redigera dem under [Inställningar → Kommunikation → Egna mallar](/settings/communication/templates). Precis som i era andra meddelanden kan ni använda #-variabler, så mallen fylls automatiskt med rätt uppgifter för jobbet. När ni har minst en mall dyker en mall-ikon upp bredvid gemet i chattrutan — både i inkorgen och i chatten på jobbsidan — och där väljer ni mallen så fylls meddelandet i åt er. Ni hittar dem också i "Meddelanden"-menyn på jobbsidan under "Egna mallar".',
}
